<template>
    <div>
        <v-btn id="IDT-btn" ref="IDTButton" :disabled="!canUseColorGradingTools" name="idt-button">
            <v-icon class="material-symbols-outlined mr-1" size="18">videocam</v-icon>
            <span class="menu-label">Select Input Transform</span>
            <i class="material-icons">expand_less</i>
            <tippy
                trigger="manual"
                hideOnClick="toggle"
                to="idt-button"
				zIndex="50"
			>
                Please Select Input Transform
            </tippy>
        </v-btn>

        <div id="IDT-menu-container" class="hide tools-menu-container scrollable-con">
<!--            <i class="arrow" data-popper-arrow></i>-->
            <div class="menu-items-container"></div>
        </div>
    </div>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import { mapState } from "vuex";

export default {
    mixins: [CanMixin],

    mounted() {
      this.$root.$refs.IDTButton = this.$refs.IDTButton;
    },

    computed: {
        ...mapState("UI", ["startTips"]),
    }
}
</script>

<style lang="scss" scoped>
#IDT-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 3px 8px !important;
    margin-left: -9px;

    &.--disabled,
    &.disabled {
        cursor: not-allowed;
    }

    > i {
        font-size: 18px;
    }

    > .menu-label {
        margin-right: 2px;
    }
}

.tools-menu-container {
    transition: none;
    display: block;
    position: absolute;
    padding: 15px 0;
    z-index: 20;
    height: 270px;
    min-width: 150px;
    background-color: #282828;
    box-shadow: 2px 2px 10px 0px #0e0e0e;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    cursor: pointer;

    > .menu-items-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        ::v-deep .menu-item {
            width: 100%;
            padding: 3px 20px;
            line-height: 1;
            transition: all 0.05s ease-in;

            &:hover {
                transition: all 0.05s ease-in;
                background: rgb(54, 54, 54);
            }

            &.first {
                order: -1;
            }
        }
    }
}
</style>